import React from 'react'

const Stats: React.FC = () => {
  return <>
  </>
}

export default Stats
